var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.71233 1.21261C8.88842 1.04497 9.12274 0.952289 9.36585 0.954128C9.60897 0.955968 9.84186 1.05218 10.0154 1.22246C10.1889 1.39275 10.2895 1.62379 10.2959 1.86682C10.3024 2.10986 10.2141 2.34589 10.0498 2.52511L5.06233 8.76261C4.97657 8.85498 4.87306 8.92911 4.758 8.98056C4.64293 9.03202 4.51867 9.05974 4.39264 9.06208C4.26662 9.06441 4.14142 9.04131 4.02453 8.99415C3.90763 8.94699 3.80145 8.87674 3.71233 8.78761L0.404831 5.48011C0.312722 5.39428 0.238845 5.29078 0.187605 5.17578C0.136365 5.06078 0.108812 4.93664 0.106591 4.81076C0.10437 4.68488 0.127526 4.55984 0.174678 4.44311C0.221829 4.32637 0.29201 4.22033 0.381033 4.13131C0.470057 4.04228 0.576099 3.9721 0.692834 3.92495C0.809569 3.8778 0.934606 3.85464 1.06048 3.85687C1.18636 3.85909 1.3105 3.88664 1.4255 3.93788C1.5405 3.98912 1.644 4.063 1.72983 4.15511L4.34733 6.77136L8.68858 1.24011C8.6964 1.23048 8.70474 1.2213 8.71358 1.21261H8.71233Z",
    fill: "#01C5F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.55ced00c8565f50df4b66094e791eccd.svg";
export { ForwardRef as ReactComponent };